<!--
	描述：日期选择弹窗
-->
<template>
	<div class="timedialog-div-bg" v-show="isshow">
		<div class="datepickerContainer">
			<div class="datepickerHeader">
				<span v-show="type == 'year'">{{nowYear}}年</span>
				<span v-show="type == 'month'">{{nowYear}}年{{nowMonth +1}}月</span>
				<span v-show="['day','dayTime'].includes(type)">{{nowYear}}年{{nowMonth +1}}月{{nowDate}}日</span>
				<span v-show="['day','dayTime'].includes(type)">{{nowWeek}}</span>
				<span v-show="type == 'dayTime'">{{time}}</span>
				<span v-if="type == 'custom'">{{timeinterval}}</span>
			</div>
			<div class="selectYearAndMonth">
				<span v-show="['day','dayTime','custom'].includes(type)"><span class="selectDateBtn" @click="monthadd(-1)">&#60;</span><span class="dateText">{{monthCn}}</span><span class="selectDateBtn" @click="monthadd(1)">&#62;</span></span>
				<span><span class="selectDateBtn" @click="year--">&#60;</span><span class="dateText">{{year}}</span><span class="selectDateBtn" @click="year++">&#62;</span></span>
			</div>
			<table class="datepickerBody" @click.stop v-show="['day','dayTime'].includes(type)">
				<tr>
					<td>日</td>
					<td>一</td>
					<td>二</td>
					<td>三</td>
					<td>四</td>
					<td>五</td>
					<td>六</td>
				</tr>
				<tr v-for="(tr,ti) in daytrs" :key="ti">
					<td width="14.2857%" v-for="(td,di) in tr" :key="di" :style='getDateSelect(td.date)' :class="{notthismonth:td.notthismonth,today:td.istoday,isselectdate:equaldate(nowDateTime,td.date)}"
					 @click="selectdate(td)"><span>{{td.date.getDate()}}</span></td>
				</tr>
				<tr v-show="type == 'dayTime'">
					<td colspan="7">
						<div class="timeInfo">
							<div class="timeInfoHover">
								<span class="timeColonOne">:</span>
								<span class="timeColonTwo">:</span>
							</div>
							<ul class="selectHour" ref="selectHour">
								<li v-for="i in timeInfoHours">{{i}}</li>
							</ul>
							<ul class="selectMinute" ref="selectMinute">
								<li v-for="i in timeInfoMinutes">{{i}}</li>
							</ul>
							<ul class="selectSecond" ref="selectSecond">
								<li v-for="i in timeInfoSeconds">{{i}}</li>
							</ul>
						</div>
					</td>
				</tr>
			</table>
			<table class="datepickerBody" @click.stop v-if="type == 'custom'">
				<tr>
					<td>日</td>
					<td>一</td>
					<td>二</td>
					<td>三</td>
					<td>四</td>
					<td>五</td>
					<td>六</td>
				</tr>
				<tr v-for="(tr,ti) in daytrs" :key="ti">
					<td width="14.2857%" v-for="(td,di) in tr" :key="di" :style='getDateSelect(td.date)' :class="{notthismonth:td.notthismonth,today:td.istoday,intimeinterval:timeintervalcontain(td.date)}"
					 @click="selectTimeInterval(td)"><span>{{td.date.getDate()}}</span></td>
				</tr>
				<tr v-show="type == 'dayTime'">
					<td colspan="7">
						<div class="timeInfo">
							<div class="timeInfoHover">
								<span class="timeColonOne">:</span>
								<span class="timeColonTwo">:</span>
							</div>
							<ul class="selectHour" ref="selectHour">
								<li v-for="i in timeInfoHours">{{i}}</li>
							</ul>
							<ul class="selectMinute" ref="selectMinute">
								<li v-for="i in timeInfoMinutes">{{i}}</li>
							</ul>
							<ul class="selectSecond" ref="selectSecond">
								<li v-for="i in timeInfoSeconds">{{i}}</li>
							</ul>
						</div>
					</td>
				</tr>
			</table>
			<table class="datepickerBody" @click.stop v-show="type == 'month'">
				<tr v-for="(tr,ti) in monthtrs" :key="ti">
					<td width="25%" v-for="(td,di) in tr" :key="di"  :style='getDateSelect(td.date)'
					:class="{nowmonth:td.isthismonth,isselectmonth:equaldate(nowDateTime,td.date)}" @click="selectMonth(td)"><span>{{td.month+1}}月</span></td>
				</tr>
			</table>
			<table class="datepickerBody" @click.stop v-show="type == 'year'">
				<tr :key='i' v-for="(tr,i) in yeartrs">
					<td width="33.33%" :key='j' v-for="(td,j) in tr"
					  :style='getDateSelect(td.date)'
					 :class="{isselectyear:equalyear(nowDateTime,td.date),nowyear:td.isthisyear}" @click="selectYear(td)"><span>{{td.year}}年</span></td>
				</tr>
			</table>
			<div class="datepickerFooter">
				<span @click="confirm">确认</span><span @click="cancel">取消</span>
			</div>
		</div>
	</div>
</template>

<script type="text/javascript">
	export default {
		name: '',
		components: {},
		props: {
			initDate: {
				type: Date,
				default () {
					return new Date()
				}
			},
			timeInterval: {
				type: Object,
				default () {
					return {}
				}
			},
			//可以使用的类型
			type: {
				validator(value) {
					return ['day', 'month', 'year', 'dayTime','custom'].indexOf(value) != -1
				},
				default: 'day'
			},
			beginCanSelect: {
				type: Date,
				default () {
					return undefined
				}
			},
			endCanSelect: {
				type: Date,
				default () {
					return undefined
				}
			}
		},
		data() {
			return {
				year: 1970,
				month: 0,
				nowDateTime: this.initDate,
				startDate: this.timeInterval.startDate,
				endDate: this.timeInterval.endDate,
				isshow: false,
				nowh: 0,
				nowm: 0,
				nows: 0,
				monthArr: ['一月','二月','三月','四月','五月','六月','七月','八月','九月','十月','十一月','十二月'],
				weekArr: ['周日','周一','周二','周三','周四','周五','周六']
			}
		},
		created() {},
		mounted() {
			this.setDate(this.initDate)
			if(this.type == 'dayTime'){
				this.addListenerWheel()
			}
		},
		destroyed() {},
		computed: {
			monthCn() {
				return this.monthArr[this.month]
			},
			nowWeek() {
				return this.weekArr[this.nowDateTime.getDay()]
			},
			nowYear() {
				return this.nowDateTime.getFullYear()
			},
			nowMonth() {
				return this.nowDateTime.getMonth()
			},
			nowDate() {
				return this.nowDateTime.getDate()
			},
			time() {
				var hours = this.nowh < 10 ? '0' + this.nowh : this.nowh
				var minutes = this.nowm < 10 ? '0' + this.nowm : this.nowm
				var seconds = this.nows < 10 ? '0' + this.nows : this.nows
				return hours + ':' + minutes + ':' + seconds
			},
			timeinterval() {
				var startYear = this.startDate.getFullYear()
				var startMonth = this.startDate.getMonth() + 1
				var startDate = this.startDate.getDate()
				var endYear = this.endDate.getFullYear()
				var endMonth = this.endDate.getMonth() + 1
				var endDate = this.endDate.getDate()
				return startYear+'年'+startMonth+'月'+startDate+'日 — '+endYear+'年'+endMonth+'月'+endDate+'日'
			},
			timeInfoHours() {
				var list = []
				list.push(this.nowh - 2 < 0 ? 23 - this.nowh : this.nowh - 2)
				list.push(this.nowh - 1 < 0 ? 23 - this.nowh : this.nowh - 1)
				list.push(this.nowh)
				list.push(this.nowh + 1 > 23 ? this.nowh + 1 - 24 : this.nowh + 1)
				list.push(this.nowh + 2 > 23 ? this.nowh + 2 - 24 : this.nowh + 2)
				list.forEach((num, index) => {
					this.$set(list, index, num >= 10 ? num : '0' + num)
				})
				return list
			},
			timeInfoMinutes() {
				var list = []
				list.push(this.nowm - 2 < 0 ? 59 - this.nowm : this.nowm - 2)
				list.push(this.nowm - 1 < 0 ? 59 - this.nowm : this.nowm - 1)
				list.push(this.nowm)
				list.push(this.nowm + 1 > 59 ? this.nowm + 1 - 60 : this.nowm + 1)
				list.push(this.nowm + 2 > 59 ? this.nowm + 2 - 60 : this.nowm + 2)
				list.forEach((num, index) => {
					this.$set(list, index, num >= 10 ? num : '0' + num)
				})
				return list
			},
			timeInfoSeconds() {
				var list = []
				list.push(this.nows - 2 < 0 ? 59 - this.nows : this.nows - 2)
				list.push(this.nows - 1 < 0 ? 59 - this.nows : this.nows - 1)
				list.push(this.nows)
				list.push(this.nows + 1 > 59 ? this.nows + 1 - 60 : this.nows + 1)
				list.push(this.nows + 2 > 59 ? this.nows + 2 - 60 : this.nows + 2)
				list.forEach((num, index) => {
					this.$set(list, index, num >= 10 ? num : '0' + num)
				})
				return list
			},
			getDateSelect(){
				return date=>{
					if (this.beginCanSelect != undefined && this.beginCanSelect.getTime() -86400000> date.getTime() ){
						return {
							'cursor':'no-drop'
						}
					}
					if ( this.endCanSelect !=undefined	 &&this.endCanSelect.getTime() < date.getTime()) {
						return {
							'cursor':'no-drop'
						}
					}
					return {}
					
				}
			},
			yeartrs() {
				var yeartrs = []
				var today = new Date()
				var nowYear = this.year;
				//被选中的年份在正中间
				for (var i = 0; i < 3; i++) {
					var tr = []
					for (var i2 = 0; i2 < 3; i2++) {
						var tarYear = nowYear + (i - 1) * 3 + (i2 - 1)
						tr.push({
							year: tarYear,
							date: new Date(tarYear, 0, 1),
							isthisyear: tarYear == today.getFullYear()
						})
					}
					yeartrs.push(tr)
				}
				return yeartrs
			},
			monthtrs() {
				var monthtrs = []
				var today = new Date()
				for (var i = 0; i < 3; i++) {
					var tr = []
					for (var j = 0; j < 4; j++) {
						var m = 4 * i + j
						tr.push({
							month: m,
							date: new Date(this.year, m, 1),
							isthismonth: this.year == today.getFullYear() && m == today.getMonth(),
						})
					}
					monthtrs.push(tr)
				}
				return monthtrs
			},
			daytrs() {
				var daytrs = []
				if (this.datelist[0] == undefined) {
					return daytrs
				}
				var firsttime = this.datelist[0].getTime()
				var lasttime = this.datelist[this.datelist.length - 1].getTime()
				var day = this.datelist[0].getDay()
				var temp = []
				for (var i = 0; i < day; i++) { //这是上个月的
					temp.push({
						notthismonth: true,
						date: new Date(firsttime - (day - i) * 24 * 60 * 60 * 1000)
					})
				}
				this.datelist.forEach(function(ele) {
					temp.push({
						notthismonth: false,
						date: ele
					})
					if (temp.length >= 7) {
						daytrs.push(temp)
						temp = []
					}
				})
				if (temp.length != 0) {
					var needadd = 7 - temp.length
					for (var i = 1; i <= needadd; i++) {
						temp.push({
							notthismonth: true,
							date: new Date(lasttime + i * 24 * 60 * 60 * 1000)
						})
					}
					daytrs.push(temp)
				}
				//如果只有5行,就再来一行,不然长度变来变去难看
				if (daytrs.length == 5) {
					temp = []
					var nowLastTime = daytrs[4][6].date.getTime()
					for (var i = 1; i <= 7; i++) {
						temp.push({
							notthismonth: true,
							date: new Date(nowLastTime + i * 24 * 60 * 60 * 1000)
						})
					}
					daytrs.push(temp)
				}
				//标记今天
				var today = new Date()
				var _this = this
				daytrs.forEach(function(tr) {
					tr.forEach(function(td) {
						if (_this.equaldate(td.date, today)) {
							td.istoday = true
						}
					})
				})
				return daytrs
			},
			datelist() { //该月份的日期列表
				var bgdate = new Date(this.year, this.month, 1)
				var enddate = new Date(this.year, this.month + 1, 1)
				var list = []
				for (var i = bgdate.getTime(); i < enddate.getTime(); i += 24 * 60 * 60 * 1000) {
					list.push(new Date(i))
				}
				return list
			},

		},
		watch: {
			nowh(nv, ov) {
				if (isempty(nv)) {
					return
				}
				if (nv != parseInt(nv)) {
					this.nowh = parseInt(nv)
				} else {
					if (nv < 0 || nv >= 24) {
						if (ov >= 0 || ov < 24) {
							this.nowh = ov
						}
					}
				}
			},
			nowm(nv, ov) {
				if (isempty(nv)) {
					return
				}
				if (nv != parseInt(nv)) {
					this.nowm = parseInt(nv)
				} else {
					if (nv < 0 || nv >= 60) {
						if (ov >= 0 || ov < 60) {
							this.nowm = ov
						}
					}
				}
			},
			nows(nv, ov) {
				if (isempty(nv)) {
					return
				}
				if (nv != parseInt(nv)) {
					this.nows = parseInt(nv)
				} else {
					if (nv < 0 || nv >= 60) {
						if (ov >= 0 || ov < 60) {
							this.nows = ov
						}
					}
				}
			},
		},
		methods: {
			addListenerWheel() {
				this.$refs.selectHour.addEventListener('wheel', (ev) => {
					if(ev.wheelDeltaY > 0){
						this.nowh = this.nowh - 1 < 0 ? 23 : this.nowh - 1
					}else{
						this.nowh = this.nowh + 1 > 23 ? 0 : this.nowh + 1
					}
				}, false)
				
				this.$refs.selectMinute.addEventListener('wheel', (ev) => {
					if(ev.wheelDeltaY > 0){
						this.nowm = this.nowm - 1 < 0 ? 59 : this.nowm - 1
					}else{
						this.nowm = this.nowm + 1 > 59 ? 0 : this.nowm + 1
					}
				}, false)
				
				this.$refs.selectSecond.addEventListener('wheel', (ev) => {
					if(ev.wheelDeltaY > 0){
						this.nows = this.nows - 1 < 0 ? 59 : this.nows - 1
					}else{
						this.nows = this.nows + 1 > 59 ? 0 : this.nows + 1
					}
				}, false)
			},
			selectdate(item) {
				if (this.beginCanSelect != undefined && (this.beginCanSelect.getTime() -86400000)> item.date.getTime()) {
					this.$dialogMethod.showMessage("当前日期不可选")
					return
				}
				if (this.endCanSelect != undefined && this.endCanSelect.getTime() < item.date.getTime()) {
					this.$dialogMethod.showMessage("当前日期不可选")
					return
				}
				this.nowDateTime = item.date
			},
			selectTimeInterval(item) {
				if (this.beginCanSelect != undefined && (this.beginCanSelect.getTime() -86400000)> item.date.getTime()) {
					this.$dialogMethod.showMessage("当前日期不可选")
					return
				}
				if (this.endCanSelect != undefined && this.endCanSelect.getTime() < item.date.getTime()) {
					this.$dialogMethod.showMessage("当前日期不可选")
					return
				}
				
				var newTime = item.date.getTime()
				var start = this.startDate.getTime()
				var end = this.endDate.getTime()
				
				if(newTime < start){
					this.startDate = item.date
				}else if(newTime > end){
					this.endDate = item.date
				}else if(newTime > start && newTime < end && (newTime - start) > (end - newTime)){
					this.endDate = item.date
				}else if(newTime > start && newTime < end && (newTime - start) <= (end - newTime)){
					this.startDate = item.date
				}
			},
			selectdatetime() {
				var d = this.nowDateTime
				
				d = new Date(d.getFullYear(), d.getMonth(), d.getDate(), this.nowh, this.nowm, this.nows)
				if (this.beginCanSelect != undefined && this.beginCanSelect.getTime() > d.getTime()) {
					this.$dialogMethod.showMessage("当前的时间不可选")
					return
				}
				if (this.endCanSelect != undefined && this.endCanSelect.getTime() < d.getTime()) {
					this.$dialogMethod.showMessage("当前时间不可选")
					return
				}
				this.$emit("selectDatetime", d)
			},
			setDate(date, timeInterval) {
				this.year = date.getFullYear()
				this.month = date.getMonth()
				if (this.type == 'month') {
					this.nowDateTime = new Date(date.getFullYear(), date.getMonth(), 1)
				} else if (this.type == 'day') {
					this.nowDateTime = date
				} else if (this.type == 'dayTime') {
					this.nowDateTime = new Date(date.getFullYear(), date.getMonth(), date.getDate())
					this.nowh = date.getHours()
					this.nowm = date.getMinutes()
					this.nows = date.getSeconds()
				} else if (this.type == 'year') {
					this.nowDateTime = new Date(date.getFullYear(), 1, 1)
				}
			},
			equaldate(d1, d2) {
				if (d1 == undefined || d2 == undefined) {
					return false
				}
				if (d1.getFullYear() == d2.getFullYear() && d1.getMonth() == d2.getMonth() && d1.getDate() == d2.getDate()) {
					return true
				}
				return false
			},
			timeintervalcontain(date) {
				if(date.getTime() >= this.startDate.getTime() && date.getTime() <= this.endDate.getTime()){
					return true
				}
				return false
			},
			equalMonth(d1, d2) {
				console.log(d1, d2)
			},
			selectMonth(item) {
				if (this.beginCanSelect != undefined && this.beginCanSelect.getTime() > item.date.getTime()) {
					this.$dialogMethod.showMessage("当前日期不可选")
					return
				}
				if (this.endCanSelect != undefined && this.endCanSelect.getTime() < item.date.getTime()) {
					this.$dialogMethod.showMessage("当前日期不可选")
					return
				}
				this.nowDateTime = item.date
				this.month = this.nowDateTime.getMonth()
			},
			equalyear(nowYear, year) {
				if (nowYear == undefined || year == undefined) {
					return false
				}
				if (nowYear.getFullYear() == year.getFullYear()) {
					return true
				}
				return false
			},
			selectYear(item) {
				if (this.beginCanSelect != undefined && this.beginCanSelect.getTime() > item.date.getTime()) {
					this.$dialogMethod.showMessage("当前日期不可选")
					return
				}
				if (this.endCanSelect != undefined && this.endCanSelect.getTime() < item.date.getTime()) {
					this.$dialogMethod.showMessage("当前日期不可选")
					return
				}
				this.nowDateTime = item.date
				this.year = item.year
			},
			equalmonth(item) {
				var nowDateTime = this.nowDateTime
				return nowDateTime.getFullYear() == item.year && nowDateTime.getMonth() == item.month
			},
			show() {
				this.isshow = true
			},
			hide() {
				this.isshow = false
			},
			monthadd(num) {
				this.month += num
				if (this.month > 11) {
					this.month = 0
					this.year++
				}
				if (this.month < 0) {
					this.month = 11
					this.year--
				}
			},
			confirm() {
				switch (this.type) {
					case 'dayTime':
						this.selectdatetime()
						break
					case 'day':
						this.$emit("selectDate", this.nowDateTime)
						break
					case 'month':
						this.$emit("selectMonth", this.nowDateTime)
						break
					case 'year':
						this.$emit("selectYear", this.nowDateTime)
						break
					case 'custom':
						this.$emit('selectTimeInterval', {startDate:this.startDate,endDate:this.endDate})
						break
				}
			},
			cancel() {
				this.hide()
			}
		}
	}
</script>

<style scoped>
	.datepickerContainer{
		color: black;
		margin: calc(50vh - 1.9rem) auto;
		/* margin: calc(50vh - 4.5rem) auto; */
		width: 3rem;
		height: auto;
		background: white;
		border: .01rem solid #cecece;
		border-radius: .05rem;
		overflow: hidden;
	}
	
	.datepickerBody {
		width: 100%;
	}
	
	.datepickerHeader{
		display: flex;
		justify-content: space-around;
		background: #588ff4;
		align-items: center;
		height: 36px;
		padding: 0 12px;
	}
	
	.datepickerHeader>span{
		color: #FFFFFF;
		font-size: 0.14rem;
	}
	
	.selectYearAndMonth{
		display: flex;
		align-items: center;
		justify-content: space-around;
		border-bottom: dashed 1px #E4E4E4;
		height: 36px;
	}
	
	.selectYearAndMonth span{
		color: #588ff4;
		font-size: .14rem;
	}
	
	.dateText{
		display: inline-block;
		width: .42rem;
		text-align: center;
	}
	
	.selectDateBtn{
		display: inline-block;
		width: .2rem;
		height: .2rem;
		text-align: center;
		cursor: pointer;
		margin: 0 .04rem;
	}

	.datepickerBody td{
		height: .35rem;
		text-align: center;
		font-size: .16rem;
		cursor: pointer;
	}
	
	.datepickerBody td>span{
		display: inline-block;
		border-radius: .06rem;
		line-height: .24rem;
	}

	.datepickerBody td.notthismonth>span {
		color: gray;
	}
	
	.datepickerBody td.today>span{
		width: .34rem;
		background: #8BB2F4;
		color: #FFFFFF;
	}
	
	.datepickerBody td.intimeinterval>span{
		width: 100%;
		line-height: 35px;
		border-radius: 0;
		background: lightgray;
	}
	
	.datepickerBody td.isselectdate>span{
		color: #FFFFFF;
		background: #F8836C;
		width: .28rem;
		line-height: .28rem;
		border-radius: 50%;
	}
	
	.datepickerBody td.nowmonth>span{
		width: .42rem;
		background: #8BB2F4;
		color: #FFFFFF;
	}
	
	.datepickerBody td.isselectmonth>span{
		width: .42rem;
		color: #FFFFFF;
		background: #F8836C;
	}
	
	.datepickerBody td.nowyear>span{
		padding: 0 .06rem;
		background: #8BB2F4;
		color: #FFFFFF;
	}
	
	.datepickerBody td.isselectyear>span{
		padding: 0 .06rem;
		color: #FFFFFF;
		background: #F8836C;
	}
	
	.datepickerFooter{
		overflow: hidden;
		padding: 3px 10px;
		border-top: dashed 1px #E4E4E4;
	}
	
	.datepickerFooter>span{
		line-height: 30px;
		float: right;
		width: 50px;
		text-align: center;
		margin-left: 6px;
		cursor: pointer;
	}
	
	.datepickerFooter>span:first-child{
		color: #588FF4;
	}
	
	.datepickerFooter>span:last-child{
		color: gray;
	}

	.timedialog-div-bg {
		position: fixed;
		width: 100%;
		height: 100%;
		left: 0;
		top: 0;
		z-index: 800;
		background: rgba(0, 0, 0, .2);
	}

	/* .datepickerBody input {
		width: calc(30%);
		text-align: center;
		vertical-align: middle;
		border: .01rem solid #CCCCCC;
		display: block;
		line-height: .3rem;
		border-radius: .1rem;
	} */

	.timeInfo {
		/* display: inline-flex;
		justify-content: space-between;
		align-items: center; */
		width: 1.8rem;
		height: .96rem;
		background: #588FF4;
		border-radius: .04rem;
		margin: 0 auto .12rem auto;
		overflow: hidden;
		position: relative;
	}
	
	.timeInfo>ul {
		position: absolute;
		width: .3rem;
		height: 1.2rem;
		text-align: center;
		overflow-y: auto;
	}
	
	.timeInfo>ul::-webkit-scrollbar{
		width: 0;
	}
	
	.timeInfoHover{
		height: .2rem;
		background: #417DDD;
		margin-top: .38rem;
	}
	
	.timeColonOne,.timeColonTwo{
		color: #FFFFFF;
		font-weight: bold;
		margin: 0 .24rem;
	}
	
	.selectHour {
		top: -0.12rem;
		left: .15rem;
	}
	
	.selectMinute {
		top: -0.12rem;
		left: .75rem;
	}
	
	.selectSecond {
		top: -0.12rem;
		left: 1.35rem;
	}
	
	.selectHour>li,.selectMinute>li,.selectSecond>li {
		color: #FFFFFF;
		line-height: .24rem;
		font-weight: bold;
		margin: 0;
	}
</style>
